import { PromoOption } from "../../../../components/promos/tipos";
import { montoEC } from "../../../../components/promos/bandaEnCamino";

/** Textos del módulo Promociones y de la Solicitud de Promoción (docs/ESPEC_SOLICITUD_PROMO.md). Código en inglés, pantalla en español. */
const ORD = ["", "1ra", "2da", "3ra", "4ta", "5ta", "6ta", "7ma", "8va", "9na", "10ma", "11va", "12va", "13va", "14va", "15va", "16va", "17va", "18va"];
/** «la 1ra» a partir de «Mensualidad 1»; si no se reconoce, el título tal cual. */
const mesDe = (title: string): string => { const n = /(\d+)\s*$/.exec(title || ""); return n && ORD[Number(n[1])] ? "la " + ORD[Number(n[1])] : (title || "").trim(); };

const S = {
	request: "Nueva Promoción",
	requestShort: "Nueva",
	requestTitle: "Nueva Promoción",
	chipRequest: "Solicitud de Promoción",
	askedBy: (name: string) => `pidió ${name}`,
	asked: "Pidió",
	applied: "Aplicó",
	// ¿Cómo Paga? y En Camino (docs/ESPEC_PROMO_EN_CAMINO.md §3 y §5)
	howPays: "¿Cómo Paga?",
	alreadyPaid: "Ya Pagó",
	atCashier: "En Caja",
	sentCaja: (promo: string, min: string) => `Lista para cobrar en Caja hoy. ${promo}, mínimo hoy ${min}.`,
	linkedHint: "Lo cambia Caja con «Cambiar Promoción»",
	/** Recuadro dorado antes de enviar: qué reemplaza, qué meses vuelven a precio normal y cuánto paga el cliente en total. */
	costoCambio: (o: PromoOption, sym: string, cargo: number): string => {   // cargo (needed) ya trae la diferencia de los meses reabiertos
		const meses = (o.reopenedMonths || []).map((m) => mesDe(m.title) + " vuelve a " + (m.listAmount != null ? montoEC(sym, m.listAmount) : "Precio Normal") + " (+" + montoEC(sym, m.difference) + ")");
		const cabeza = o.replaces ? `Reemplaza «${o.replaces}»` : "Reabre meses";
		return `${cabeza}${meses.length ? ": " + meses.join(" y ") : ""}. El cliente paga ${montoEC(sym, cargo)} en total.`;
	},
	// Pestañas En Camino y Fallidas (docs/ESPEC_PROMO_EN_CAMINO.md §4)
	tabEnCamino: "En Camino",
	tabFailed: "Fallidas",
	search: "Buscar",
	searchEc: "Alumno",
	noName: "Sin Nombre",
	noAdvisors: "Sin asesoras",
	colStudent: "Alumno", colPromo: "Promoción", colProgress: "Avance", colDue: "Vence", colEnded: "Terminó", colAdvisors: "Asesoras",
	emptyEc: "Sin Promociones En Camino",
	emptyFailed: "Sin Promociones Fallidas",
	ecMeta: "Meta", ecMinToday: "Mínimo del Día", ecPaid: "Lleva", ecRemaining: "Faltan", ecStart: "Arranque", ecDue: "Vence", ecAttempt: "Intento",
	ecCourse: "Matrícula", ecGift: "Curso Regalado", ecBy: "La Dejó Lista",
	ecPayments: "Pagos", ecReceipt: "Recibo", ecNoPayments: "Sin pagos", ecHistory: "Historial", ecNoHistory: "Sin movimientos",
	ecCancel: "Cancelar Promoción", ecCancelReason: "Motivo (mínimo 10 letras)", ecCancelConfirm: "Sí, Cancelar",
	// Secciones del formulario
	person: "Persona",
	searchPlaceholder: "Nombre, correlativo o teléfono",
	searching: "Buscando…",
	noResults: "Sin resultados.",
	change: "Cambiar",
	enrollment: "Curso",
	loadingEnrollments: "Buscando sus cursos…",
	noEnrollments: "No tiene cursos con promoción de adelanto.",
	promosFor: (n: number) => n === 1 ? "1 promoción" : `${n} promociones`,
	payment: "Pago",
	amount: "Monto",
	date: "Fecha de Pago",
	method: "Método",
	account: "Cuenta Receptora",
	reference: "Referencia",
	vouchers: "Comprobante",
	addVoucher: "Agregar Otro",
	takePhoto: "Tomar Foto o Elegir Archivo",
	photoOrPdf: "Foto o PDF",
	usePhone: "Usar el Celular",
	maxFiles: (n: number) => `Hasta ${n} archivos.`,
	tooBig: "Un archivo pasa de 10 MB: toma la foto otra vez o súbelo en PDF.",
	promo: "Promoción",
	typeAmount: "Escribe el monto para ver qué promoción le toca.",
	noPromos: "Sin promociones para este curso.",
	loadingPromos: "Cargando…",
	advisors: "Asesoras",
	notes: "Notas",
	notesPlaceholder: "Opcional. Lo que Caja deba saber.",
	send: "Enviar a Caja",
	sendEnCaja: "Dejar Lista en Caja",
	sending: "Enviando…",
	sent: "Enviada a Caja. La ves en Por Aplicar.",
	sentTicket: (id: number) => `Ticket #${id}`,
	another: "Hacer Otra",
	done: "Listo",
	close: "Cerrar",
	cancel: "Cancelar",
	notFits: (name: string, diff: string, faltan: boolean) => `El monto no cuadra con «${name}» (${faltan ? "faltan" : "sobran"} ${diff}). Caja lo revisará.`,
	missing: {
		person: "Elige a la persona.",
		enrollment: "Elige el curso.",
		amount: "Escribe el monto.",
		files: "Sube el comprobante.",
		promo: "Elige la promoción.",
		gift: "Elige el regalo.",
		twoForOne: "Elige el curso regalado.",
		checking: "Revisando el curso regalado…",
	},
	// Devueltas por Caja
	returned: "Devueltas por Caja",
	returnedEmpty: "Sin devoluciones.",
	reason: "Motivo",
	resend: "Enviar Comprobante Nuevo",
	resendNote: "Nota (opcional)",
	resendSend: "Enviar",
	resent: (id: number) => `Enviado otra vez a Caja como ticket #${id}.`,
	// Lista y ventanas de detalle (rediseño 2026-11-01, como Matrículas)
	title: "Promociones",
	empty: "Sin promociones.",
	col: { id: "#", student: "Alumno", promo: "Promoción", amount: "Monto", paid: "Cobrado", gift: "Regalado", advisors: "Asesoras", status: "Estado", date: "Fecha", progress: "Avance", due: "Vence", ended: "Terminó", delivery: "Entrega" },
	kpiApplied: "Aplicadas", kpiPaid: "Cobrado", kpiGift: "Regalado", kpiPct: "% Regalado",
	subAnuladas: "Anuladas", subFallidas: "Fallidas",
	statusPending: "Por Aplicar",
	returnedBadge: "Devuelta por Caja",
	detailTitle: (id: number) => `Promoción #${id}`,
	ecTitle: (id: number) => `En Camino #${id}`,
	ticketTitle: (id: number) => `Ticket #${id}`,
	pendingTitle: "Por Aplicar",
	openInCaja: "Abrir en Caja",
	goesTo: (who: string) => `Le toca a ${who}`,
	noTicket: "Sin ticket todavía",
	goDeliver: "Ir a Entregar",
	changePromo: "Cambiar Promoción",
	cancelledBy: (who: string, when: string) => "Anulada" + (who ? " por " + who : "") + (when ? " el " + when : ""),
	replaced: (promos: string) => `Reemplazó a ${promos}`,
	nToDeliver: (faltan: number, de: number) => (de > 1 ? `${faltan} de ${de} Sin Entregar` : "Sin Entregar"),
};

export default S;
